var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('h1',{staticClass:"section-title"},[_vm._v(_vm._s(_vm.header))]),_c('hr',{staticClass:"section-hr"}),_c('div',{staticClass:"col-sm-1"}),_c('div',{staticClass:"about-team-image col-sm-10"},[_c('img',{attrs:{"src":_vm.imageSrc}})])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }